import { useCallback } from "react";
import { Button } from "@/components/ui/Button";

interface Props {
  onClear: () => void;
  disabled?: boolean;
}

/**
 * Botón reutilizable para limpiar el formulario de consulta y reiniciar
 * los resultados en pantalla, dejando el formulario listo para una
 * nueva consulta.
 */
export const LimpiarConsultaButton = ({ onClear, disabled = false }: Props) => {
  const onClick = useCallback(() => {
    if (disabled) return;
    onClear();
  }, [disabled, onClear]);

  return (
    <Button
      type="button"
      variant="secondary"
      size="md"
      onClick={onClick}
      disabled={disabled}
      aria-label="Limpiar NITs y reiniciar resultados"
    >
      Limpiar
    </Button>
  );
};
